<template lang='pug'>
  div(id="root")
    app-radio
    router-view
</template>

<script>
  import AppRadio from './AppRadio'
  import { mapActions } from 'vuex'
  export default {
    components: { AppRadio },

    methods: {
      ...mapActions({
        loadCategories: 'loadCategories',
        loadCompany: 'loadCompany'
      })
    },

    created () {
      this.loadCategories()
      this.loadCompany()
    }
  }
</script>



// WEBPACK FOOTER //
// src/app/components/Root.vue